



























































































import Vue from 'vue'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import { FETCH_SEARCH_PRODUCT_LIST } from '@/store/action-types'
import { ProductSearchResponse } from '@/types/service-response'
import { ProductSearchResult } from '@/model/project/ProductSearchResult'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import { SearchAddressEmployee } from '@/model/addresses/SearchAddressEmployee'
import CreateProjectAddressSearch from '@/components/project/CreateProjectAddressSearch.vue'

interface ComponentData {
  loading: boolean
  productList: ProductSearchResult[]

  showSearchAddressDialog: boolean
  address: string
  selectedAddressId: number | null
  selectedSachbearbeiterId: number | null

  lieferantList: any[]
  lieferant: any | null
  lagerList: any[]
  lager: any | null
  produktgruppeList: any[]
  produktgruppe: any | null
  abteilungList: any[]
  abteilung: any | null
  mitarbeiterList: any[]
  mitarbeiter: any | null
  prozessartList: any[]
  prozessart: any | null

  focusedRowKey: number
}

export default Vue.extend({
  name: 'DispositionSearch',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxStateStoring,
    CreateProjectAddressSearch
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    searchString: String,
    foundList: Array as () => ProductSearchResult[]
  },

  data (): ComponentData {
    return {
      loading: false,
      productList: [],

      showSearchAddressDialog: false,
      address: '',
      selectedAddressId: null,
      selectedSachbearbeiterId: null,

      lieferantList: [],
      lieferant: null,
      lagerList: [],
      lager: null,
      produktgruppeList: [],
      produktgruppe: null,
      abteilungList: [],
      abteilung: null,
      mitarbeiterList: [],
      mitarbeiter: null,
      prozessartList: [],
      prozessart: null,

      focusedRowKey: -1,
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    onSearchAddressClick (): void {
      this.showSearchAddressDialog = true
    },

    closeSearchAddressDialog (): void {
      this.showSearchAddressDialog = false
    },

    onSelectedAddress (data: SearchAddress): void {
      this.showSearchAddressDialog = false
      this.address = data && data.genAdresse? data.genAdresse.replace(/\n/g, "<br />") : ''
      this.selectedAddressId = data.id
      this.selectedSachbearbeiterId = null
    },

    onSelectedAddressEmployee (data: SearchAddressEmployee): void {
      this.showSearchAddressDialog = false
      this.address = data && data.genAdresse ? data.genAdresse.replace(/\n/g, "<br />") : ''
      this.selectedAddressId = data.adressID
      this.selectedSachbearbeiterId = data.sachbearbeiterID
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onKeyDown (e: any): void {
      if(e.event.key === "Enter") {
        const foundProduct: ProductSearchResult | undefined = this.productList.find((item: ProductSearchResult) => item.produkt === this.focusedRowKey)
        if(foundProduct) {
          this.$emit('selectedProduct', foundProduct)
        }
      }
    },

    rowDblClick (event: any): void {
      this.$emit('selectedProduct', event.data)
    },

    onSearchButtonClick (): void {
      this.searchProduct()
    },

    onFocusedCellChanging (e: any) {
      e.isHighlighted = false
    },

    onFocusedRowChanged (e: any): void {
      this.focusedRowKey = e.component.option('focusedRowKey')
    },

    async searchProduct (): Promise<void> {
      const payload: any = {



        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId
      }

      try {
        this.loading = true
        const response: ProductSearchResponse = await this.$store.dispatch(FETCH_SEARCH_PRODUCT_LIST, payload)
        if(!response.IsError && response.Results) {
          this.productList = ProductSearchResult.createFromResponse(response.Results)

          if(this.productList.length > 0) {
            //@ts-ignore
            this.$refs.dataGrid.instance.option("focusedRowIndex", -1);

            this.focusedRowKey = 0
            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid.instance.focus()
              this.focusedRowKey = this.productList[0].produkt
            }, 100)
          }
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    }
  },

  mounted (): void {
    this.productList = this.foundList ? this.foundList : []

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
